const defaultIcon = `
  <svg
    width="11"
    height="10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="5.5" cy="5" r="5" fill="#9A67FF" />
  </svg>`;

function generateId() {
  return Math.random().toString(36).substr(2, 9);
}

function resolveIcon() {
  const id = generateId();

  return `
    <svg
      width="11"
      height="10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="5.5" cy="5" r="5" fill="url(#${id}" />
      <defs>
        <linearGradient
          id="${id}"
          x1="1.5"
          y1=".5"
          x2="18"
          y2="14.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".042" stop-color="#F33" />
          <stop offset=".387" stop-color="#48F2F2" />
          <stop offset=".656" stop-color="#FCFF85" />
        </linearGradient>
      </defs>
    </svg>
  `;
}

function generateFcpIcon() {
  const id = generateId();

  return `
    <svg
      width="11"
      height="10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="5.5" cy="5" r="5" fill="url(#${id}" />
      <defs>
        <linearGradient
          id="${id}"
          x1="1.75"
          y1="1"
          x2="9"
          y2="9.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#91FF53" />
          <stop offset="1" stop-color="#FF4F43" />
        </linearGradient>
      </defs>
    </svg>
  `;
}

export default function generateCategories() {
  return {
    presets: [
      {
        icon: defaultIcon,
        text: 'Adobe After Effects',
        link: '/browse/after-effects-presets/',
      },
      {
        icon: defaultIcon,
        text: 'Adobe Premiere Pro',
        link: '/browse/premiere-pro-presets/',
      },
      {
        icon: resolveIcon(),
        text: 'DaVinci Resolve Macros',
        link: '/browse/davinci-resolve-macros/',
      },
    ],

    templates: [
      {
        icon: defaultIcon,
        text: 'Adobe After Effects',
        link: '/browse/after-effects-templates/',
      },
      {
        icon: defaultIcon,
        text: 'Adobe Premiere Pro',
        link: '/browse/premiere-pro-templates/',
      },
      {
        icon: defaultIcon,
        text: 'Motion Graphics',
        link: '/browse/motion-graphics-templates/',
      },
      {
        icon: defaultIcon,
        text: 'Adobe Premiere Rush',
        link: '/browse/premiere-rush-templates/',
      },
      {
        icon: resolveIcon(),
        text: 'Davinci Resolve',
        link: '/browse/davinci-resolve-templates/',
      },
      {
        icon: generateFcpIcon(),
        text: 'Final Cut Pro',
        link: '/browse/final-cut-pro-templates/',
      },
    ],

    audio: [
      {
        icon: `
          <svg
            width="23"
            height="24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 12C0 5.649 5.149.5 11.5.5S23 5.649 23 12s-5.149 11.5-11.5 11.5S0 18.351 0 12z"
              fill="#666"
            />
            <path
              d="M11.5 14.25c1.242 0 2.25-.984 2.25-2.25V8.25A2.25 2.25 0 0011.5 6a2.236 2.236 0 00-2.25 2.25V12c0 1.266.984 2.25 2.25 2.25zm3.563-3.75a.555.555 0 00-.563.563V12a3 3 0 01-3.21 3c-1.548-.094-2.79-1.547-2.79-3.117v-.82a.57.57 0 00-.563-.563.555.555 0 00-.562.563v.773c0 2.086 1.477 3.96 3.563 4.242v.797H10a.751.751 0 00-.75.797c0 .187.164.328.375.328h3.75c.188 0 .352-.14.352-.328.023-.422-.305-.797-.727-.797h-.938v-.773c1.993-.282 3.563-2.016 3.563-4.102v-.938a.57.57 0 00-.563-.562z"
              fill="#1A1A1A"
            />
          </svg>
        `,
        text: 'Royalty Free Music',
        link: '/browse/royalty-free-music/',
      },
      {
        icon: `
          <svg
            width="23"
            height="24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 12C0 5.649 5.149.5 11.5.5S23 5.649 23 12s-5.149 11.5-11.5 11.5S0 18.351 0 12z"
              fill="#666"
            />
            <path
              d="M16 13.781V6.562c-.021-.365-.322-.687-.688-.687a.635.635 0 00-.214.043l-6.875 2.02c-.258.085-.473.386-.473.666v4.94a2.548 2.548 0 00-.688-.107c-1.16 0-2.062.774-2.062 1.72 0 .966.902 1.718 2.063 1.718 1.138 0 2.062-.752 2.062-1.719v-4.469l5.5-1.61v3.093a2.548 2.548 0 00-.688-.107c-1.16 0-2.062.773-2.062 1.718 0 .967.902 1.719 2.063 1.719 1.138 0 2.062-.752 2.062-1.719z"
              fill="#1A1A1A"
            />
          </svg>
        `,
        text: 'Sound Effects',
        link: '/browse/sound-effects/',
      },
    ],

    videos: [
      {
        icon: `
          <svg
            width="24"
            height="24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M.5 12C.5 5.649 5.649.5 12 .5S23.5 5.649 23.5 12 18.351 23.5 12 23.5.5 18.351.5 12z"
              fill="#666"
            />
            <path
              d="M14.063 9.281c0-.558-.473-1.031-1.032-1.031H6.844c-.58 0-1.032.473-1.032 1.031v6.188c0 .58.452 1.031 1.032 1.031h6.187c.559 0 1.031-.451 1.031-1.031V9.28zm4.124.344c0-.537-.644-.86-1.095-.559L14.75 10.7v3.373l2.342 1.633c.451.3 1.096-.021 1.096-.559V9.625z"
              fill="#1A1A1A"
            />
          </svg>
        `,
        text: 'Footage',
        link: '/browse/stock-video/',
      },
      {
        icon: `
          <svg
            width="24"
            height="24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M.5 12C.5 5.649 5.649.5 12 .5S23.5 5.649 23.5 12 18.351 23.5 12 23.5.5 18.351.5 12z"
              fill="#666"
            />
            <path
              d="M13.188 12.375a.839.839 0 00-.258-.58L9.148 7.842a.83.83 0 00-1.203-.022.83.83 0 00-.021 1.203l3.201 3.352-3.201 3.373a.83.83 0 00.021 1.203.83.83 0 001.203-.021l3.782-3.953a.848.848 0 00.258-.602zm3.867-.58l-3.782-3.953a.83.83 0 00-1.203-.022.83.83 0 00-.021 1.203l3.201 3.352-3.201 3.373a.83.83 0 00.021 1.203.83.83 0 001.203-.021l3.782-3.953a.848.848 0 00.258-.602.839.839 0 00-.258-.58z"
              fill="#1A1A1A"
            />
          </svg>
        `,
        text: 'Motion Graphics',
        link: '/browse/stock-motion-graphics/',
      },
    ],

    tools: [
      {
        text: 'Extension',
        link: '/integrations/adobe/',
      },
    ],

    images: [
      {
        icon: `
        <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect y="0.5" width="23" height="23" rx="11.5" fill="#B3B3B3"/>
          <path d="M8.65625 9.46484C8.26562 9.58203 7.93359 9.89453 7.81641 10.2852L6 15.7539L6.27344 16.0273L9.20312 13.0977C9.14453 12.9805 9.10547 12.8438 9.10547 12.707C9.10547 12.1797 9.53516 11.7695 10.043 11.7695C10.5703 11.7695 10.9805 12.1797 10.9805 12.707C10.9805 13.2148 10.5703 13.6445 10.043 13.6445C9.90625 13.6445 9.76953 13.6055 9.65234 13.5469L6.72266 16.4766L6.99609 16.75L12.4648 14.9336C12.8555 14.8164 13.168 14.4844 13.2852 14.0938L14.1055 11.1445L11.6055 8.64453L8.65625 9.46484ZM15.707 8.21484L14.5352 7.04297C14.1836 6.67188 13.5781 6.67188 13.207 7.04297L12.1133 8.13672L14.6133 10.6367L15.707 9.54297C16.0781 9.17188 16.0781 8.56641 15.707 8.21484Z" fill="white"/>
        </svg>
      `,
        text: 'Graphics',
        link: '/browse/graphics/',
      },
      {
        icon: `
        <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect y="0.5" width="23" height="23" rx="11.5" fill="#B3B3B3"/>
          <path d="M14.75 7.375H7.25C6.54688 7.375 6 7.94141 6 8.625V14.875C6 15.5781 6.54688 16.125 7.25 16.125H14.75C15.4336 16.125 16 15.5781 16 14.875V8.625C16 7.94141 15.4336 7.375 14.75 7.375ZM8.1875 8.625C8.69531 8.625 9.125 9.05469 9.125 9.5625C9.125 10.0898 8.69531 10.5 8.1875 10.5C7.66016 10.5 7.25 10.0898 7.25 9.5625C7.25 9.05469 7.66016 8.625 8.1875 8.625ZM14.7109 14.7188C14.6523 14.8164 14.5352 14.875 14.4375 14.875H7.60156C7.46484 14.875 7.36719 14.8164 7.30859 14.7188C7.26953 14.6016 7.26953 14.4844 7.34766 14.3867L8.71484 12.5117C8.77344 12.4336 8.85156 12.375 8.96875 12.375C9.06641 12.375 9.14453 12.4336 9.20312 12.5117L9.84766 13.3906L11.6641 10.6562C11.7227 10.5586 11.8203 10.5 11.9375 10.5C12.0352 10.5 12.1328 10.5586 12.1914 10.6562L14.6914 14.4062C14.75 14.5039 14.75 14.6211 14.7109 14.7188Z" fill="white"/>
        </svg>
      `,
        text: 'Photos',
        link: '/browse/stock-video/',
      },
    ],

    photos: '/browse/stock-photos/',
    plugins: '/plugins/',
    learn: '/learn/',
  };
}
